import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d9a239b2")

_pushScopeId("data-v-d9a239b2")
const _hoisted_1 = { class: "single-tab" }
const _hoisted_2 = { class: "flex_centers" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      _createVNode("li", null, _toDisplayString($props.title), 1)
    ])
  ]))
})